import React from 'react';

interface MaterialSymbolProps {
    /** Icon-Name aus Material Symbols Rounded, z. B. "school" oder "hourglass_top" */
    name: string;
    /** Schriftgröße in px (Default 20 aus .material-symbols-rounded) */
    size?: number;
    /** Gefüllte Variante (FILL-Achse) für aktive/ausgewählte Zustände */
    filled?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Marken-Icon aus dem selbst gehosteten Material-Symbols-Rounded-Subset
 * (public/fonts/MaterialSymbolsRounded.woff2, Klasse in azubi-web-styles.css).
 *
 * Das Subset enthält nur die im Design verwendeten Icons. Wird ein neues Icon
 * gebraucht: Namen in design-system-seed/fonts/msr-subset-fontface.css-Workflow
 * ergänzen (Google-Fonts-URL mit icon_names) und die woff2 neu herunterladen.
 */
export const MaterialSymbol: React.FC<MaterialSymbolProps> = ({ name, size, filled, className, style }) => (
    <span
        className={`material-symbols-rounded${filled ? ' is-filled' : ''}${className ? ` ${className}` : ''}`}
        style={size ? { fontSize: size, ...style } : style}
        aria-hidden="true"
    >
        {name}
    </span>
);

export default MaterialSymbol;
